import styled from "@emotion/styled";
import type { FC } from "react";

export interface InformationClassificationProps {
  classification: "INTERNAL" | "CONFIDENTIAL" | "SECRET" | "EXTERNAL";
}

const InformationClassificationText = styled.span({
  display: "inline-block",
  textAlign: "center",
  fontSize: "20px",
  lineHeight: "20px",
  fontWeight: 400,
  paddingTop: "2px",
  paddingBottom: "2px",
  borderTop: "1px solid",
  borderBottom: "1px solid",
  userSelect: "none",
  fontFamily: "AGMedium",
});

export const InformationClassification: FC<InformationClassificationProps> = ({
  classification,
}) => {
  const color: string = {
    INTERNAL: "#26ADE8",
    CONFIDENTIAL: "#FF7F41",
    SECRET: "#E40076",
    EXTERNAL: "#009FE4",
  }[classification];

  return (
    <InformationClassificationText style={{ color: color, borderColor: color }}>
      {classification}
    </InformationClassificationText>
  );
};
